import { arrayToKeyValueObj } from '../utils/types.utils'

const tableCellVariants = {
    header: 'th',
    standard: 'td'
}

const tableCellAlignArray = ['start', 'center', 'end', 'left', 'right'];
const tableCellAlign = arrayToKeyValueObj(tableCellAlignArray)


export {
    tableCellVariants,
    tableCellAlign
}